import React from 'react';
import { toastr } from 'react-redux-toastr';
import { toTitleCase } from '../../../lib/utils';
import LoadingSpinner from './LoadingSpinner';

export default class InfiniteScrollList extends React.Component {

    state = {
        hasMore: true,
        prevScrollPosition: 0,
        showScrollToTop: false
    };

    componentWillMount() {
        this.props.getRecords();
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.success && this.props.success) {
            toastr.error("Something went wrong", `We couldn't retrieve ${this.props.name || "records"}.  Please try again`);
        }
    }

    getListHeader = () => {
        const { columns, sort } = this.props;

        return columns
            .filter(column => !column.hidden)
            .map(column => <th key={column.id}>
                <div className="relative">
                    <div className={`sort flex-center ${sort && sort.by === column.id ? "active" : ""}`}>
                        {
                            column.component || <p className="sort-arrows-label">{column.title}</p>
                        }
                        {
                            column.sortable && <div className={`sort-arrows relative ${sort && sort.by === column.id ? "active" : ""}`} onClick={() => this.sortList(column)}>
                                <i className={`icon ion-android-arrow-dropup ${sort.direction !== 'Ascending' ? "inactive" : ""}`}></i>
                                <i className={`icon ion-android-arrow-dropdown ${sort.direction !== 'Descending' ? "inactive" : ""}`}></i>
                            </div>
                        }
                    </div>
                </div>
            </th>);
    }

    getListRecords = () => {
        const { records, renderRecord } = this.props;
        return records.map(rec => renderRecord(rec));
    }

    sortList = column => {
        const { sort } = this.props;
        const updatedSort = {
            by: column.id,
            direction: sort.by !== column.id
                ? (column.defaultDirection ? column.defaultDirection : "Ascending")
                : (sort.direction === "Ascending" ? "Descending" : "Ascending")
        };
        this.props.getRecords(1, updatedSort, true);
    }

    onScroll = event => {
        const { hasMore, loading, page, sort } = this.props;
        const { showScrollToTop } = this.state;
        
        const isHorizontalScroll = event.target.scrollTop === this.state.prevScrollPosition;
        const distanceFromBottom = event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop;
        if (!loading && hasMore && !isHorizontalScroll && distanceFromBottom <= 250) { //TODO: adjust as needed!
            this.props.getRecords(page + 1, sort);
            this.setState({ prevScrollPosition: event.target.scrollTop });
        }

        const hasScroll = event.target.scrollTop > (event.target.clientHeight + 250);
        if (hasScroll && !showScrollToTop) {
            this.setState({ showScrollToTop: true });
        } else if (!hasScroll && showScrollToTop) {
            this.setState({ showScrollToTop: false });
        }
    }

    scrollToTop = () => {
        if (this.refs.infiniteList)
            this.refs.infiniteList.scrollTo({ "behavior": "smooth", "left": 0, "top": 0 });
    }

    render() {
        const { hideScrollToTopButton, loading, name, records } = this.props;
        const { showScrollToTop } = this.state;

        return (
            <div
                className="container infinite-scroll-list"
                ref="infiniteList"
                onScroll={this.onScroll}>
                {(!loading && !records.length)
                    ? <p className="empty-state">
                        <i className="material-icons">not_interested</i>
                        <span>No {toTitleCase(name) || 'Records'} Found</span>
                    </p>
                    : <div>
                        <div className="table-container">
                            {loading && <div className="row table-loader-row">
                                <div className="table-view__loader loader-row">
                                    <div className="loader-row__cell lrc-1"></div>
                                    <div className="loader-row__cell lrc-2"></div>
                                    <div className="loader-row__cell lrc-3"></div>
                                    <div className="loader-row__cell lrc-4"></div>
                                    <div className="loader-row__cell lrc-5"></div>
                                    <div className="loader-row__cell lrc-6"></div>
                                    <div className="loader-row__cell lrc-7"></div>
                                    <div className="loader-row__cell lrc-8"></div>
                                    <div className="loader-row__cell lrc-9"></div>
                                    <div className="loader-row__cell lrc-10"></div>
                                    <div className="loader-row__cell lrc-11"></div>
                                </div>
                            </div>}
                            <table className="table">
                                <thead>
                                    <tr className="table-header table-row">
                                        {this.getListHeader()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getListRecords()}
                                </tbody>
                            </table>
                            {(loading && records.length > 0) && <LoadingSpinner height="20" />}
                            {(showScrollToTop && !hideScrollToTopButton) &&
                                <button
                                    className="btn btn-top btn-primary"
                                    onClick={this.scrollToTop}>
                                    <i className="material-icons">arrow_upward</i></button>}
                        </div>
                    </div>}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/InfiniteScrollList.jsx